import { useForm } from "@inertiajs/react"

const useDeleteGame = () => {
  const { delete: handleDelete, processing } = useForm()

  const deleteGame = (id: string) => {
    handleDelete(`/games/${id}`, {
      async: true,
    })
  }

  return {
    deleteGame,
    processing,
  }
}

export default useDeleteGame
